/* Shared API path builders used by the application and unit tests. */
export function pathBuilder(config) {
  return {
    login: `${config.baseURI}/cognito/login`,
    loginCou: `${config.baseURI}/cognito/login-cou`,
    loginOtp: `${config.baseURI}/cognito/login-otp`,
    getNewAccessToken: `${config.baseURI}/cognito/refresh-token`,
    logout: `${config.baseURI}/cognito/logout`,
    getContractFile: `${config.baseURI}/contract/{ContractType}/{Version}/file.html`,
    submitContractAgreement: `${config.baseURI}/contract/{ContractType}/{Version}/agreement`,
    getContractsToSign: `${config.baseURI}/contract/contracts-to-sign`,
    getCommunicationConsent: `${config.baseURI}/communicationconsent/get-communication-consent`,
    updateCommunicationConsent: `${config.baseURI}/communicationconsent/upsert-communication-consent`,
    getMemberships: `${config.baseURI}/membership`,
    submitMembershipChangeRequest: `${config.baseURI}/membership/change-membership`,
    getMembershipDependents: `${config.baseURI}/member/dependents?status=active`,
    membershipDependents: `${config.baseURI}/member/dependents`,
    getServiceOfferingUsage: `${config.baseURI}/membership/membership-service-offering-usage`,
    health: `${config.baseURI}/health/get-health-check`,
    healthProfile: `${config.baseURI}/healthprofile/get-health-profile`,
    healthProfileNewEntry: `${config.baseURI}/healthprofile/new-entry`,
    mobileHealthData: `${config.baseURI}/HealthProfile/mobile-health-data`,
    submitFaceScanMeasurements: `${config.baseURI}/healthprofile/binah-submit-results`,
    healthRecord: `${config.baseURI}/healthprofile/events`,
    healthRecordEvent: `${config.baseURI}/healthprofile/event/{type}`,
    getHealthScoreQuestionnaire: `${config.baseURI}/healthprofile/questionnaire/{type}`,
    submitHealthScoreQuestionnaire: `${config.baseURI}/healthprofile/questionnaire-submission`,
    healthTrends: `${config.baseURI}/healthprofile/health-trends/{health-trend-type}`,
    healthDataShare: `${config.baseURI}/health-data-share/{healthDataShareIdentifier}`,
    getMyBenefits: `${config.baseURI}/Product/my-benefits`,
    getMyBenefitsWithProductCode: `${config.baseURI}/Product/my-benefits?productCode={productCode}`,
    healthProfileHaveANurseCallMeBackCheck: `${config.baseURI}/member/request-nurse-call-back-check`,
    skipCommunicationConsent: `${config.baseURI}/member/skip-communication-consent`,
    getMember: `${config.baseURI}/member/get-member`,
    getMemberRequiredActions: `${config.baseURI}/member/required-actions`,
    getMemberServiceOfferingUsages: `${config.baseURI}/member/serviceoffering/{type}/usages?status=active`,
    submitMemberAcknowledgeEvent: `${config.baseURI}/member/acknowledge-event/{EventType}`,
    getMemberContactDetails: `${config.baseURI}/member/get-member-contact-details`,
    healthRecordHaveNurseCallMeBackEvent: `${config.baseURI}/member/request-nurse-call-back`,
    submitRetailUserDetails: `${config.baseURI}/member/member-personal-details`,
    getDoctorList: `${config.baseURI}/member/get-doctors`,
    startMemberConsultation: `${config.baseURI}/member/start-consultation`,
    getMemberProductPaymentRates: `${config.baseURI}/member/product-payment-rates`,
    getMemberConsultations: `${config.baseURI}/member/consultations`,
    getMemberConsultationOutcome: `${config.baseURI}/member/consultations/{ConsultationId}`,
    submitRating: `${config.baseURI}/member/service-ratings`,
    reportIssue: `${config.baseURI}/issue/create`,
    getMessages: `${config.notificationsBaseURI}/in-app?skipCount={skipCount}&listLength={listLength}`,
    getMessageDetails: `${config.notificationsBaseURI}/in-app/{messageId}`,
    deleteMessage: `${config.notificationsBaseURI}/in-app/{messageId}`,
    updateMessage: `${config.notificationsBaseURI}/in-app`,
    registerDeviceToken: `${config.notificationsBaseURI}/devices`,
    getDevices: `${config.notificationsBaseURI}/devices`,
    markAllMessagesAsRead: `${config.notificationsBaseURI}/in-app/mark-all-read`,
    getMarketingChannels: `${config.baseURI}/marketingchannel`,
    submitPublicFaceScanData: `${config.baseURI}/liberty/capture-vitals`,
    getDirectToDoctorPrimarySymptoms: `${config.baseURI}/condition/primary-symptoms`,
    getMemberProfile: `${config.baseURI}/member/profile`,
    getMarketingChannelsStores: `${config.baseURI}/marketingchannel/{id}/locations?province={province}`,
    getMarketingChannelsProvinces: `${config.baseURI}/marketingchannel/{id}/provinces`,
    getPathologyPanelsList: `${config.chronicCareBaseURI}/panels`,
    getPathologyOrderDetails: `${config.chronicCareBaseURI}/orders/{id}`,
    emailOptOut: `${config.baseURI}/communicationconsent/{id}/opt-out-email`,
    getPathologyPanelById: `${config.chronicCareBaseURI}/panels/{id}`,
    pathologyOrders: `${config.chronicCareBaseURI}/orders`,
    getMemberPurchases: `${config.baseURI}/member/purchases?skipCount={skipCount}&listLength={listLength}`,
    initiatePathologyPayment: `${config.baseURI}/pathology/initiate-order-payment?pathologyOrderId={id}&productAmount={amount}&productCode=BLOOD_WORK&memberId={memberId}&memberServiceOfferingUsageId={memberServiceOfferingUsageId}&oneVoucherPin={oneVoucherPin}`,
    pathologyPayment: `${config.baseURI}/pathology/get-payment-page?pathologyOrderId={id}`,
    getPathologyPaymentReceipt: `${config.baseURI}/pathology/payment-receipt?pathologyOrderId={id}`,
    getVoucherTypes: `${config.baseURI}/Voucher/vendor/voucher-types`,
    initiateVoucherPayment: `${config.baseURI}/voucher/initiate-order-payment?voucherDefinitionId={id}&voucherCode={voucherCode}`,
    getVoucherPaymentReceipt: `${config.baseURI}/voucher/payment-receipt?voucherOrderId={id}`,
    getMemberVouchers: `${config.baseURI}/member/vouchers`,
    voucherPayment: `${config.baseURI}/voucher/get-payment-page?voucherOrderId={id}`,
    applyVoucher: `${config.baseURI}/voucher/apply`,
    getVoucherDownload: `${config.baseURI}/voucher/download?voucherOrderId={id}`,
    oneVoucherPayment: `${config.baseURI}/payment/carecard/pay/onevoucher`,
    requestPayment: `${config.baseURI}/member/consultation/{consultationId}/request-payment`,
    initiateConsultationPayment: `${config.baseURI}/payment/initiate-consultation-payment`,
    consultationPayment: `${config.baseURI}/payment/consultation/get-payment-page?memberLedgerId={id}`,
    getConsultationPaymentReceipt: `${config.baseURI}/member/consultations/payment-receipt?externalConsultationId={id}`,
    getMemberDiscountVouchers: `${config.baseURI}/member/discount-vouchers`,
    applyDiscountVoucher: `${config.baseURI}/voucher/discount/apply`,
    healthScoreSummary: `${config.baseURI}/healthscore/summary`,
  };
}
